<template>
  <v-main class="pa-4" fluid>
    <v-row >

      <v-snackbar v-model="alerta.activo" vertical top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>
      

      <v-col cols="12">
        <v-card  class="shadowCard" >

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold grey--text"> Cotizaciones </span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn color="green darken-1" outlined   @click="initPedidos()">
              <b>Actualizar</b>
            </v-btn>
	  		  </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="6" sm="4" md="2">
                <v-text-field
                  v-model="fecha1"
                  name="name"
                  label="Fecha inicial"
                  dense
                  hide-details
                  filled
                  type="date"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="4" md="2">
                <v-text-field
                  v-model="fecha2"
                  name="name"
                  label="Fecha Final"
                  dense
                  hide-details
                  filled
                  type="date"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    filled
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>
            
            <v-row >
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="pedidos"
                  class="elevation-0"
                  :search="search"
                  :height="tamanioPantalla"
                  fixed-header
                  :loading ="Loading"
                >
                  <template v-slot:item.cliente="{ item }" >
                    <span v-if="item.cliente"> {{ item.cliente.nombre.concat(' ', item.cliente.apellido ) }}  </span>
                    <span v-else class="error--text"> CLIENTE SIN CUENTA </span>
                  </template>
                  
                  <template v-slot:item.fecha="{ item }">
                    {{ moment(item.fecha).format('llll') }}
                  </template>

                  <template v-slot:item.subtotal="{ item }">
                    {{ item.subtotal | currency(2) }}
                  </template>
                  <template v-slot:item.envio="{ item }">
                    {{ item.envio | currency(2) }}
                  </template>
                  <template v-slot:item.descuento="{ item }">
                    % {{ item.descuento ? item.descuento : 0 }}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ item.total | currency(2) }}
                  </template>

                  <!-- <template v-slot:item.pagado="{ item }">
                    <v-chip class="btnSuccess" small v-if="item.pagado.length > 0">Pagado</v-chip>
                    <v-chip color="red"   dark small v-else>No pagado</v-chip>
                  </template> -->

                  <template v-slot:item.estatus="{ item }" c>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 0"> Generado</v-btn>
                    <v-btn text rounded class="btnSuccess" small v-if="item.estatus == 1"> Pagado</v-btn>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 2"> Cancelado</v-btn>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 3"> por entregar</v-btn>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 4"> Retenido</v-btn>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 5"> Entregado</v-btn>
                    <v-btn text rounded color="black" dark small v-if="item.estatus == 6"> Finalizado</v-btn>
                  </template>

    
                  <template v-slot:item.actions="{ item }" > 
                    <span class="mx-1">
                      <v-icon  
                        color="primary" 
                        small dark fab
                        icon 
                        @click="modalPedido = true; 
                        parametros = item"
                      >
                        mdi-eye
                      </v-icon> 
                    </span>

                    <span  class="mx-1">
                      <v-icon 
                        color="info" 
                        class="normal" 
                        small fab  
                        icon
                        :disabled="item.estatus != 1"
                        @click="modalMakilador=true; parametros=item"
                      >
                        mdi-gift-open-outline</v-icon>
                      </v-icon>
                    </span>
                    <span class="mx-1">
                      <v-icon
                        color="error"
                        class=" normal"
                        small  fab
                        icon
                        :disabled="item.estatus == 0 || item.estatus == 2 || item.estatus == 4 || item.estatus == 5 "
                        @click="modalRetencion=true; parametros=item"
                      >
                        mdi-lock-alert
                      </v-icon>
                    </span>

                    <span class="mx-1">
                      <v-icon
                        color="blue"
                        class=" normal"
                        small fab
                        icon
                        @click="modalHistorial=true; parametros=item"
                        :disabled="item.estatus < 1"
                      >
                        mdi-truck-fast-outline
                      </v-icon>
                    </span>

                    <!-- <span class="mx-1">
                      <v-icon
                        color="success"
                        class=" normal"
                        small fab
                        icon
                        @click="modalHistorial=true; parametros=item"
                        :disabled="item.estatus != 5"
                      >
                        mdi-cannabis
                      </v-icon>
                    </span> -->
                   
                  </template>

                </v-data-table>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-dialog v-model="modalPedido" width="800">
        <v-card class="pa-4">
          <controlPedidos 
            :parametros="parametros"
            @modal="modalPedido = $event" />
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalMakilador" width="400" >
        <v-card class="pa-4">
            <controlMaquilador
              :parametros="parametros"
              @modal="modalMakilador = $event;"
            />
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalHistorial" width="800" >
        <v-card class="pa-4">
            <controlHistorial
              :parametros="parametros"
              @modal="modalHistorial = $event;"
            />
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="modalRetencion" width="500" >
        <v-card class="pa-4">
            <controlRetencion
              :parametros="parametros"
              @modal="modalRetencion = $event;"
            />
        </v-card>
      </v-dialog>

    </v-row>
  </v-main>
</template>

<script>
  import Vue from 'vue'
  import  metodos from '@/mixins/metodos.js';
  import controlPedidos from '@/views/administrativo/Pedidos/control_pedidos.vue'
  import controlMaquilador from '@/views/administrativo/Pedidos/control_maquilador.vue'
  import controlHistorial from '@/views/administrativo/Pedidos/control_historial.vue'
  import controlRetencion from '@/views/administrativo/Pedidos/control_retencion.vue'

	import {mapGetters, mapActions} from 'vuex'
	var accounting = require("accounting");
  var moment     = require('moment'); moment.locale('es') /// inciar Moment 
  
  export default {
    mixins:[metodos],
    components: {
			controlPedidos,
      controlMaquilador,
      controlHistorial,
      controlRetencion
		},
    data: () => ({
      page: 0,
      pageCount: 0,
      itemsPerPage: 100,
      search:'',
      pedidos:[],
      headers: [
        { text: 'Pedido'          , align: 'start'  , sortable: false, value: 'iddocum'    },
        { text: 'Cliente'         , align: 'start'  , sortable: false, value: 'cliente'    },

        { text: 'Fecha de compra' , align: 'start'   , sortable: false, value: 'fecha'      },
        { text: 'Subtotal'        , align: 'right'  , sortable: false, value: 'subtotal'   },
        { text: 'Envio'           , align: 'right'  , sortable: false, value: 'envio'      },
        { text: 'Descuento'       , align: 'right' , sortable: false, value: 'descuento'  },
        { text: 'Total'           , align: 'right'  , sortable: false, value: 'total'      },
        // { text: 'Pagado'          , align: 'right'  , sortable: false, value: 'pagado'    },
        { text: 'Estatus'         , align: 'start'  , sortable: false, value: 'estatus'    },
        { text: 'Actions'         , align: 'start'  , sortable: false, value: 'actions'    },
      ],

      alerta: { activo: false, texto:'', color:'error' },
      Loading: false,

      parametros: {},
      modalPedido: false,
      modalMakilador: false,
      modalHistorial: false,
      modalRetencion: false,
      modalValidarAsignacion: false, 
      

      bodegas:[],
      bodega:{idbodegas:null, nombre:''},
      maquiladores: [],
      maquilador:{ id: null, nombre:'' },
      obs_asignacion_maquilador: '',

      fecha1:moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD"), 
      fecha2: moment().subtract('months').endOf('months').format("YYYY-MM-DD"),



    }),

    computed: {
      ...mapGetters('Login',['getusuarioFetish']),
    },

    watch: {
      async bodega(){
        let idBodegas = this.bodega.idbodegas;
        let idNiveles = 3
        this.maquiladores = await this.consultar_tipo_usuario(idBodegas, idNiveles);
      }
    },

    filters:{
      currency(val, dec){
        return accounting.formatMoney(val, '$', dec)
      }
    },

    created () {
      this.initPedidos();
      	// this.$router.push({name:'verpedido',params:{docum: pedido}})

    },

    methods: {
      initPedidos () {
        this.Loading = true;

        const payload = {
          fecha1: this.fecha1,
          fecha2: this.fecha2
        }

        this.$http.post('ordenes.list', payload).then( response =>{
          console.log(response.body)
          this.pedidos = response.body
        }).catch( error =>{
          console.log('error', error)
        }).finally(()=>{ this.Loading = false})
      },
    },

    finalizarProceso(){
        this.initPedidos();
      }
  }
</script>

<style scoped>
  .normal{
    text-transform: none;
  }
</style>